/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description blog constants
 */

export const START_FETCHING_BLOG_POSTS = '@@nzr/blog/START_BLOG_POSTS'
export const CANCEL_FETCHING_BLOG_POSTS = '@@nzr/blog/CANCEL_BLOG_POSTS'
export const RECEIVE_BLOG_POSTS = '@@nzr/blog/RECEIVE_BLOG_POSTS'
export const CLEAR_BLOG_POSTS = '@@nzr/blog/CLEAR_BLOG_POSTS'
export const ERROR_FETCHING_BLOG_POSTS = '@@nzr/blog/ERROR_BLOG_POSTS'
export const DONE_FETCHING_BLOG_POSTS = '@@nzr/blog/DONE_BLOG_POSTS'
